import { createContext, type ReactNode, useContext } from "react";
import type { CMSComponentProps } from "~/features/cms/types/props";

export type CMSComponentRenderer = (
  props: CMSComponentProps,
  className?: string,
  key?: number,
) => null | JSX.Element;

const CMSComponentRendererContext = createContext<CMSComponentRenderer | null>(null);
let defaultRenderer: CMSComponentRenderer | null = null;

export function initializeCMSComponentRenderer(renderer: CMSComponentRenderer): void {
  defaultRenderer = renderer;
}

export const CMSComponentRendererProvider = ({
  renderer,
  children,
}: {
  renderer: CMSComponentRenderer;
  children: ReactNode;
}) => <CMSComponentRendererContext.Provider value={renderer}>{children}</CMSComponentRendererContext.Provider>;

export function useCMSComponentRenderer(): CMSComponentRenderer {
  const renderer = useOptionalCMSComponentRenderer();
  if (!renderer) {
    throw new Error("CMS component renderer has not been initialized");
  }
  return renderer;
}

export function useOptionalCMSComponentRenderer(): CMSComponentRenderer | null {
  return useContext(CMSComponentRendererContext) ?? defaultRenderer;
}
